import service from '@services/cart/updateAddress';
import { errorAction, successfulAction } from '@shared/actions';
import getCartId from '@core/reducers/cart/selectors/getCartId';
import { CHANGE_ADDRESS } from '@core/reducers/cart/actionTypes';
import isOutOfDeliveryError from '@utils/cart/isOutOfDeliveryError';

const type = CHANGE_ADDRESS;
const errorMessage =
  'Ocurrió un error al cambiar la dirección. Por favor intente nuevamente';

const changeAddress = ({ address, setOutOfDeliveryError = true }) => async (
  dispatch,
  getState,
  axios,
) => {
  try {
    dispatch({ type });
    const cartId = getCartId(getState());

    const { success, data, error } = await service({ axios, cartId, address });

    if (success) {
      dispatch(successfulAction({ type, payload: data }));
    } else {
      const outOfDeliveryError = isOutOfDeliveryError(error);
      dispatch(
        errorAction({
          type,
          error,
          errorMessage,
          mute: outOfDeliveryError,
          payload: { setOutOfDeliveryError },
        }),
      );
    }

    return success ? data : null;
  } catch (error) {
    dispatch(errorAction({ type, error, errorMessage }));
    return null;
  }
};

export default changeAddress;
